module.exports = __webpack_public_path__ + "static/media/watercolorsmakemesmile-IG.b44ebc1f.PNG";